import React from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends React.PureComponent {
  state = { hasRenderError: false };

  componentDidCatch(/*error, info*/) {
    // Display fallback UI
    this.setState({ hasRenderError: true });
    // You can also log the error to an error reporting service
    //logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasRenderError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return React.Children.only(this.props.children);
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
